/**
 * Checkbox de consentimiento de Términos + Política (Sprint 14 S14.3, R2 GDPR).
 *
 * Obligatorio en el registro (nativo y social). Los enlaces a /terms y
 * /privacy abren en una pestaña nueva para no perder el formulario en curso.
 * El texto del label se compone desde i18n intercalando los enlaces.
 */
import { t } from "@/i18n/es";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}

export function ConsentCheckbox({ checked, onChange, error }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <label className="flex items-start gap-2 text-sm text-bone-muted">
        <input
          type="checkbox"
          data-testid="register-consent-checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 accent-lime"
        />
        <span>
          {t.auth.consentLabelPrefix}
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime underline underline-offset-2"
          >
            {t.auth.consentTermsLink}
          </a>
          {t.auth.consentLabelMid}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime underline underline-offset-2"
          >
            {t.auth.consentPrivacyLink}
          </a>
          {t.auth.consentLabelSuffix}
        </span>
      </label>
      {error && (
        <p
          role="alert"
          data-testid="register-consent-error"
          className="text-xs text-danger"
        >
          {error}
        </p>
      )}
    </div>
  );
}
